import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Store } from '@ngrx/store';
import { LocalStorageService, SessionStorageService, SharedStorageService } from 'ngx-store';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as fromRoot from "../../_store";
import { ApiEndpoints } from '../../http/api-endpoints';
import { Base64Utils } from '../../utils/Base64Utils';
import { AdministratorModeActions, DeputyActions } from '../../_store';
import { Logout } from 'src/app/_store/actions';
import { User } from '../../models/user.model';
import { JulContextLibService } from 'jul-web-shared-lib/src/lib/components/context';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  userToken: any;
  decodedToken: any;
  currentUser: User;
  loggedOut: BehaviorSubject<any> = new BehaviorSubject<any>(false);

  private photoUrl = new BehaviorSubject<string>('../../assets/user.png');
  currentPhotoUrl = this.photoUrl.asObservable();

  constructor(private http: HttpClient,
              public jwtHelper: JwtHelperService,
              public localStorageService: LocalStorageService,
              public sessionStorageService: SessionStorageService,
              public sharedStorageService: SharedStorageService,
              private julContextService: JulContextLibService,
              private store: Store<fromRoot.CoreState>) { }

  getEntities( username: string, password: string ) {
    this.julContextService.setContextNational();
    return this.http
      .post<any>(ApiEndpoints.core.auth.userEntities(), { username: username, password: password, confirmPassword: '' });
  }

  login(username: string, password: string, businessEntityId: string) {
    this.julContextService.setContextNational();
    return this.http
      .post<any>(ApiEndpoints.core.auth.login(), { username: username, password: password, confirmPassword: '', businessEntityId: businessEntityId });
  }

  processAuthRequest( data: any) {
    // tslint:disable-next-line:no-debugger
    localStorage.setItem( 'token', data.token );
    this.decodedToken = this.jwtHelper.decodeToken( data.token );
    this.currentUser = { ...data, role: "all" };

    if( data.photo ) {
      let mime = Base64Utils.getImgMimeType( data.photo );
      let photo = {
        base64: data.photo,
        preview: "data:" + mime + ";base64," + data.photo
      }
      this.currentUser.photo = photo;
    }

    this.userToken = data.user;
    localStorage.setItem('user', JSON.stringify(this.currentUser));
    if(data.remainingDaysToPasswordExpiration) {
      localStorage.setItem('remainingDaysToPasswordExpiration', data.remainingDaysToPasswordExpiration);
    }
  }

  setToken(token:any){
    localStorage.setItem('token', token);
  }
  getToken(){
    return localStorage.getItem('token');
  }
  getUser(token:any){
    this.julContextService.setContextNational();
    return this.http.post<any>(ApiEndpoints.core.auth.validate(), token).pipe(
      map((response: any)  => response.data)
    );
  }
  validateToken(token: string) {
    this.julContextService.setContextNational();
      return this.http
        .post<any>(ApiEndpoints.core.auth.validate(), token)
        .pipe(
          map(user => {
            if (user && user.data && user.data.token) {
              // tslint:disable-next-line:no-debugger
              localStorage.setItem('token', user.data.token);
              this.decodedToken = this.jwtHelper.decodeToken(user.data.token);
              this.currentUser = user.data;
              this.userToken = user.data.user;
              localStorage.setItem('user', JSON.stringify(this.currentUser));
            }
          })
        );
    }

  logout(): Observable<any> {
    this.julContextService.setContextNational();
    return this.http.post<any>( ApiEndpoints.core.auth.logout(), null).pipe(map(data => {
      this.clearStorage();
    }));
  }

  getCurrentBusinessEntityId() {
    return this.decodedToken.org;
  }

  getRedirectAT(returnUrl: string) {
    this.julContextService.setContextNational();
    return this.http.get<any>( ApiEndpoints.core.auth.redirectAT(returnUrl) );
}

  clearStorage() {
    this.store.dispatch( new DeputyActions.DeleteActiveDeputy() );
    this.store.dispatch( new DeputyActions.DeleteActiveImpersonalization() );
    localStorage.clear();
    sessionStorage.clear();
    this.loggedOut.next(true);
    this.loggedOut.complete();
    this.store.dispatch(new Logout());
    this.store.dispatch( new AdministratorModeActions.DeleteMenu() );
    // this.sharedStorageService.clear('all');
  }

  loggedIn() {
    const token = this.jwtHelper.tokenGetter();

    if (!token || token == 'undefined') {
      return false;
    }

    return !this.jwtHelper.isTokenExpired();
  }
  isTokenExpired() {
    return this.jwtHelper.isTokenExpired();
  }


  loginAT( nif: string, userId: string, credential: string ) {
    this.julContextService.setContextNational();
    return this.http
      .post<any>(ApiEndpoints.core.auth.loginAT(), { nif: nif, userId: userId, credential: credential })
      .pipe(
        map(user => {
          if (user && user.data && user.data.token) {
            // tslint:disable-next-line:no-debugger
            localStorage.setItem('token', user.data.token);
            this.decodedToken = this.jwtHelper.decodeToken(user.data.token);
            this.currentUser = { ...user.data, role: "all" };
            this.userToken = user.data.user;
            localStorage.setItem('user', JSON.stringify(this.currentUser));
          }
        })
      )
  }
}
